import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse, OwnerType } from "types";

type useGofacOwnerReRunMutationProps = {
	id: number;
	onSuccessHandler?: Function;
	ownerType: OwnerType;
};

const useGofacOwnerReRunMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, ownerType }: useGofacOwnerReRunMutationProps) =>
			autoChecklistService.reRunGOFACOwner(id, ownerType),
		{
			onSuccess(_, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "gOFAC re-run was successful",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGofacOwnerReRunMutation;
